import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';

// maxWidthClassName defaults to the original fixed width (max-w-xl) so every
// existing call site (confirmation dialogs, small forms) renders unchanged;
// pass a wider Tailwind max-w-* class for content that needs more room (e.g.
// the workflow builder's reference modals).
export default function DialogModal({ open, setOpen, title, children, maxWidthClassName = 'max-w-xl' }) {
  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} className="relative z-50 w-96">
        {/* The backdrop, rendered as a fixed sibling to the panel container */}
        <DialogBackdrop className="fixed inset-0 bg-black/30" />

        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className={`w-full ${maxWidthClassName} space-y-4 bg-white p-12`}>
            <DialogTitle className="font-bold">{title}</DialogTitle>

            {children}
          </DialogPanel>
        </div>
      </Dialog>
    </>
  )
}
